import DisplayValueViewer from 'components/ScalarSpreadsheet/utilities/DisplayValueViewer';
import FastValueViewer from 'components/ScalarSpreadsheet/utilities/FastValueViewer';
import { Cell } from 'components/Spreadsheet/components';
import DisplayCell from 'components/Spreadsheet/components/Cell/DisplayCell';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

/**
 * @description controls the cellRenderer and the valueViewer depending on if the displayCellRuntime is desired or not
 * @param useDisplayCellRuntime controls if the display cell is used or not
 * @returns
 */
const getSpreadsheetCellRuntime = (useDisplayCellRuntime?: boolean) => ({
  cellRenderer: useDisplayCellRuntime ? DisplayCell : Cell,
  valueViewer: useDisplayCellRuntime ? DisplayValueViewer : FastValueViewer,
});

/**
 * DataCell is a PureComponent and shallow-compares renderer props. Editable sheets
 * mutate cells in place (cap-table conditions attaching GridDateValueViewer, alias
 * assignment, hidden flags). A stable renderer identity skips those updates, so
 * locators like `#A3-date_viewer` never appear. Display-runtime sheets (firm summary)
 * push values through AsyncCell context instead and can keep a stable identity.
 */
export const withDatasheetUpdateIdentity = <T extends (cell: ICell) => unknown>(
  renderer: T,
  freezeIdentity: boolean
): T => (freezeIdentity ? renderer : (((cell: ICell) => renderer(cell)) as T));

export const getEditableDatasheetValueRenderer = (
  useDisplayCellRuntime?: boolean
): ((cell: ICell) => string | number) | undefined =>
  useDisplayCellRuntime ? undefined : (cell: ICell) => cell.value as string | number;

export default getSpreadsheetCellRuntime;
